import { selectTechMapSymbolOptions } from '@/entities/tech-map';
import { useGetTechMapSymbolCatalogQuery, useLazyGetUniqueRubberTechMapSymbolsQuery } from '@/shared/state/api/swagger';
import { FC } from 'react';
import { filterOption } from '../../lib/filter-option';
import { FilterSelect } from './filter-select';
import { useCallback, useEffect } from 'react';

export const GroupSelect: FC<{ name?: string }> = ({ name = 'symbol' }) => {
	const { options, isFetching } = useGetTechMapSymbolCatalogQuery(undefined, {
		selectFromResult: (result) => ({ ...result, options: selectTechMapSymbolOptions(result?.data) }),
	});

	return (
		<FilterSelect
			label="Группа"
			name={name}
			options={options}
			isLoading={isFetching}
			alertName="Введите группу"
			filterOption={filterOption}
		/>
	);
};

export const RubberGroupSelect: FC = () => {
	const [trigger, { options, isFetching }] = useLazyGetUniqueRubberTechMapSymbolsQuery({
		selectFromResult: (result) => ({
			...result,
			options: result.data?.map((num) => ({ value: num, label: num })) ?? [],
		}),
	});

	const onSearch = useCallback(({ stringToSearch }: { stringToSearch: string }) => {
		trigger({ stringToSearch });
	}, []);

	useEffect(() => {
		trigger({});
	}, []);

	return (
		<FilterSelect
			label="Группа"
			name="symbol"
			options={options}
			isLoading={isFetching}
			onSearch={onSearch}
			alertName="Введите группу"
		/>
	);
};
